import React from "react";
import CustomTable from "../../helpers/customtable";
import formatPrice from "../../helpers/formatPrice";
import "../../../css/WorksTable.css";

export default function WorksTable({
  isUser,
  t,
  workList,
  loading,
  handleRowClick,
  handleDeleteWork
}) {
  const column = (key, header, width, align = "left") => ({
    key,
    header: t(header),
    shortHeader: t(`worksHeaderShort_${header}`),
    width,
    align,
    formatValue: ["paid", "price", "laborCost"].includes(key)
      ? formatPrice
      : undefined,
    default: t("none")
  });
  const dateColumn = (key, header) => ({
    ...column(key, header, "10%"),
    sortValue: (row) => row.sortDates[key]
  });
  const config = {
    rowKey: "workId",
    emptyText: t("noWorks"),
    pageSize: 10,
    showPageSizeSelector: true,
    pageSizeOptions: [10, 25, 50, 100],
    showTotalCount: true,
    labels: { actions: t("actions"), filter: t("filter"), search: t("search") },
    columns: [
      column("id", "id", "10%"),
      column("partyName", isUser ? "client" : "user", "13%"),
      { ...column("name", "workName", isUser ? "9%" : "15%"), fixed: true },
      column("paid", "paid", "10%", "right"),
      column("price", "totalPrice", "10%", "right"),
      column("laborCost", "laborCost", "10%", "right"),
      column("status", "status", "9%"),
      ...(isUser ? [dateColumn("measureDate", "measured")] : []),
      dateColumn("orderDate", "ordered"),
      dateColumn("finishDate", "completed"),
      {
        key: "actions",
        width: "4%",
        text: "...",
        actionlist: [
          {
            key: "delete",
            label: t("delete"),
            icon: "bi-trash",
            visible: (work) => work.canDelete,
            onClick: (work) => handleDeleteWork(work.workId)
          }
        ]
      }
    ],
    onRowClick: (work) => handleRowClick(work.workId)
  };

  return (
    <div className="works-table">
      <CustomTable data={workList} config={config} loading={loading} />
    </div>
  );
}
